import { render, staticRenderFns } from "./ModalWhatsapp.vue?vue&type=template&id=00f47135"
import script from "./ModalWhatsapp.vue?vue&type=script&lang=js"
export * from "./ModalWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports